import React, { Component } from 'react';
import axios from 'axios';
import ReactTable from 'react-table';
import 'react-table/react-table.css';

import Loader from '../nav/Loader';

const baseResultsURL = "https://www.roadtonationals.com/api/men/allscoressplit";

class AllTeamScores extends Component {
  constructor(props) {
      let data = [
        {team_name: 'Air Force', date: 'Jan-01-2017', floor: '9.5', phorse: '9.5', rings: '9.5', vault: '10', pbars: '10', highbar: '10', team_score: '50' }
      ];
      let columns = [
        {
          Header: 'Teams',
          accessor: 'team_name',
          Cell: props => <a href={'/results/teamsGA/dashboard/'+this.state.yearFilter+'/'+props.original.team_id}>{props.value}</a>
        },
        {Header: 'Date', accessor: 'meet_date', Cell: props => <a href={'/results/scheduleGA/meet/'+props.original.meet_id}>{props.value}</a>},
        {Header: 'Floor', accessor: 'floor'},
        {Header: 'Phorse', accessor: 'phorse'},
        {Header: 'Rings', accessor: 'rings'},
        {Header: 'Vault', accessor: 'vault'},
        {Header: 'Pbars', accessor: 'pbars'},
        {Header: 'Highbar', accessor: 'highbar'},
        {Header: 'Team Score', accessor: 'team_score', Cell: props => <strong>{props.value}</strong>},
      ];
      super(props);
      this.state = {
        data: data,
        cols: columns,
        numRows: 0,
        yearFilter: props.yearFilter,
        showLoader: true
      };
      this.defaultSortMethod = this.defaultSortMethod.bind(this);
      this.getYear = this.getYear.bind(this);
  }
  componentWillReceiveProps(nextProps) {
    //console.log(nextProps);
    if(nextProps.yearFilter !== this.state.yearFilter) {
      this.getResults({
        "year": nextProps.yearFilter
      });
      this.setState({
        yearFilter : nextProps.yearFilter,
        showLoader: true
      });
    }
  }
  componentWillMount() {
    this.getResults({
      "year": this.state.yearFilter
    });
  }
  getResults(config) {
    var url = baseResultsURL + '/' + config.year + '/' + 1;
    axios.get(url)
    .then(response => {
      if (!response.data){

      } else {
        var length = response.data.length;
        this.setState({
          data : response.data,
          numRows : length,
          showLoader: false
        });
      }
    })
    .catch(function (error) {
      console.log(error);
    });
  }
  getYear() {
    return this.state.yearFilter;
  }
  defaultSortMethod(a, b) { //desc
    // force null and undefined to the bottom
    a = (a === null || a === undefined) ? -Infinity : a
    b = (b === null || b === undefined) ? -Infinity : b
    // force any string values to lowercase
    a = a === 'string' ? a.toLowerCase() : a
    b = b === 'string' ? b.toLowerCase() : b

    // Return either 1 or -1 to indicate a sort priority
    if (a > b) {
      return -1
    }
    if (a < b) {
      return 1
    }
    // returning 0, undefined or any falsey value will use subsequent sorts or the index as a tiebreaker
    return 0
  }
  getChart() {
    if(!this.state.showLoader) {
      return <div className="small-12 columns">
        <ReactTable
          className="-striped -highlight"
          data={this.state.data}
          columns={this.state.cols}
          defaultSortMethod={this.defaultSortMethod}
          showPagination={false}
          defaultPageSize={this.state.numRows}
          pageSize={this.state.numRows}
        />
        <br />
        <p className="note">*This chart displays every team score in a particular year and allows sorting by event.</p>
      </div>;
    } else {
      return <Loader />;
    }
  }
  render() {
    return (
      <div>
          <div className="row expanded">
              {this.getChart()}
          </div>
      </div>
    );
  }
}

export default AllTeamScores;



// WEBPACK FOOTER //
// ./src/components/allteams/AllTeamScores.js